import styled from 'styled-components';

import { Modal } from '@/core/components/Modal';
import { ASIDE_WIDTH, HEADER_HEIGHT } from '@/core/components/Layout/Layout.styles';
import { useTopmostZIndex } from '@/core/hooks/useTopmostZIndex';

import { ChatBot } from './ChatBot';

type ChatBotModalProps = {
  isOpen: boolean;
  focusId?: number | null;
  onClose: () => void;
  onSaveSuccess?: (focusId?: number) => void;
};

const ModalContent = styled.div`
  width: calc(100vw - ${ASIDE_WIDTH});
  height: 100%;
  min-height: 100%;
  background-color: ${({ theme }) => theme.colors.background.dark};
  pointer-events: auto;
`;

export const ChatBotModal = ({ isOpen, focusId, onClose, onSaveSuccess }: ChatBotModalProps) => {
  const zIndex = useTopmostZIndex(isOpen);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      matchContentSize={false}
      height={`calc(100vh - ${HEADER_HEIGHT})`}
      zIndex={zIndex}
      positionX="flex-end"
      positionY="flex-start"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      style={{
        overlay: {
          pointerEvents: 'none',
        },
      }}
      overlayPosition={{
        top: HEADER_HEIGHT,
        right: '0',
        left: '0',
      }}
    >
      <ModalContent>
        <ChatBot
          focusId={focusId}
          onClose={onClose}
          onSaveSuccess={onSaveSuccess}
        />
      </ModalContent>
    </Modal>
  );
};
